import React, {Fragment} from 'react' ;

import { renderExtensions, validateExtension } from "./autoformExtensionRenderers";
import UserInputControlled from "./UI/UserInputControlled";
import UserInputTextareaControlled from "./UI/UserInputTextareaControlled";
import UserInputDate from "./UI/UserInputDate";
import DropdownYesNo from "./UI/DropdownYesNo";

import Toggle from "react-toggle";

const renderUserInput = (props, definition, fieldHandlers) =>
{
    return (
        <UserInputControlled onChange={fieldHandlers.getChangeHandlerForType('input')}
                             id={definition.ref}
                             autofocus={definition.autoFocus}
                             name={definition.ref}
                             label={definition.label}
                             errorText={definition.errorText}
                             defaultValue={fieldHandlers.getFieldValue(definition.ref)}
                             value={fieldHandlers.getFieldValue(definition.ref)}
                             readOnly={props.readonly === true || definition.readonly === true || props.mode === 'view' ? 'readonly' : ''}
                             isValid={fieldHandlers.isFieldValid(definition.ref)}
                             key={definition.ref}
                             tabIndex={definition.tabIndex}
                             renderErrorDiv={fieldHandlers.shouldDisplayErrors() && !fieldHandlers.isFieldValid(definition.ref)}/>
    )
}

const renderUserInputTextarea = (props, definition, fieldHandlers) =>
{
    return (
        <UserInputTextareaControlled onChange={fieldHandlers.getChangeHandlerForType('input')}
                                     id={definition.ref}
                                     autofocus={definition.autoFocus}
                                     name={definition.ref}
                                     label={definition.label}
                                     errorText={definition.errorText}
                                     defaultValue={fieldHandlers.getFieldValue(definition.ref)}
                                     value={fieldHandlers.getFieldValue(definition.ref)}
                                     rows={definition.rows}
                                     readOnly={props.readonly === true || props.mode === 'view' || definition.disabled === true ? 'readonly' : ''}
                                     isValid={fieldHandlers.isFieldValid(definition.ref)}
                                     key={definition.ref}
                                     tabIndex={definition.tabIndex}
                                     renderErrorDiv={fieldHandlers.shouldDisplayErrors() && !fieldHandlers.isFieldValid(definition.ref)}/>
    )
}

const renderUserInputDate = (props, definition, fieldHandlers) =>
{
    return (
        <UserInputDate onChange={fieldHandlers.getChangeHandlerForType('date')}
                       id={definition.ref}
                       autofocus={definition.autoFocus}
                       name={definition.ref}
                       label={definition.label}
                       errorText={definition.errorText}
                       className=''
                       defaultValue={fieldHandlers.getFieldValue(definition.ref)}
                       value={fieldHandlers.getFieldValue(definition.ref)}
                       readonly={props.readonly === true || props.mode === 'view' || definition.disabled === true ? 'readonly' : ''}
                       isValid={fieldHandlers.isFieldValid(definition.ref)}
                       key={definition.ref}
                       tabIndex={definition.tabIndex}
                       renderErrorDiv={fieldHandlers.shouldDisplayErrors() && !fieldHandlers.isFieldValid(definition.ref)}/>
    )
}

const renderToggle = ( props, definition, fieldHandlers ) =>
{
    const value = fieldHandlers.getFieldValue(definition.ref) ;

    const checked = +value === 1 || value === true ? true : false ;

    return (
        <Fragment>
            <div className='form-group'>
                <label style={{verticalAlign: 'super'}} htmlFor={definition.ref}>{definition.label}</label>
                <Toggle
                    id={definition.ref}
                    defaultChecked={ checked }
                    onChange={fieldHandlers.getChangeHandlerForType('toggle')}
                    name={definition.ref}
                    readOnly={props.readonly === true || definition.readonly === true || props.mode === 'view' ? 'readonly' : ''}
                />
            </div>
        </Fragment>
    )
}

const renderYesNo = ( props, definition, fieldHandlers ) =>
{

    return (
            <DropdownYesNo
                onChange={fieldHandlers.getChangeHandlerForType('dropdown')}
                name={definition.ref}
                label={definition.label}
                key={definition.ref}
                errorText={definition.errorText}
                dataType={definition.data_type}
                value={fieldHandlers.getFieldValue(definition.ref)}
                id={definition.ref}
                readOnly={props.readonly === true || props.mode === 'view' ? 'readonly' : ''}
                renderErrorDiv={fieldHandlers.shouldDisplayErrors() && !fieldHandlers.isFieldValid(definition.ref)}
            />
    )
}

const renderField = ( props, definition, fieldHandlers ) =>
{
    switch (definition.field_type)
    {
        case 'input':
            return renderUserInput(props, definition, fieldHandlers);
        case 'textarea':
            return renderUserInputTextarea(props, definition, fieldHandlers) ;
        case 'date':
            return renderUserInputDate(props, definition, fieldHandlers) ;
        case 'toggle':
            return renderToggle(props, definition, fieldHandlers) ;
        case 'dropdown_yesno':
            return renderYesNo(props, definition, fieldHandlers);

        default:
            // If we haven't found a renderer pass to the project specific one
            return renderExtensions(props, definition, fieldHandlers) ;
    }
}

const validateField = ( definition, value ) =>
{
    let isValid = true ;

    switch (definition.field_type)
    {
        case 'input':
            if ( definition.validation !== undefined )
            {
                if ( definition.validation.required === true )
                {
                    if (value.length === 0)
                    {
                        isValid = false;
                    }
                }
            }
            break ;
        case 'date':
            if ( definition.validation !== undefined )
            {
                if ( definition.validation.required === true )
                {
                    if (value.length === 0)
                    {
                        isValid = false;
                    }
                }
            }
            break ;
        default:
            return validateExtension ( definition, value );
    }

    return isValid ;
}

export { renderField, validateField } ;